<div #bmPortal class="cv-body-portal">
  <div
    class="cv-dm-backdrop"
    *ngIf="isOpen"
    (click)="onBackdropClick($event)"
    role="presentation"
  >
    <div
      class="cv-dm-card"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cv-bm-title"
    >
      <div class="cv-dm-header cv-dm-header--divider">
        <h2 class="cv-dm-header__title" id="cv-bm-title">
          BBox search results
        </h2>
        <button
          type="button"
          class="cv-dm-header__close"
          (click)="closeModal.emit()"
          aria-label="Close"
          title="Close"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <div
        id="cv-bm-filter-panel"
        class="cv-dm-filter-panel cv-dm-filter-panel--always"
        role="region"
        aria-label="BBox search filters"
        [attr.aria-busy]="filtersLoading()"
      >
        <div class="cv-dm-filter-panel__toolbar">
          <p class="cv-dm-filter-panel__hint" *ngIf="filtersLoading()">
            Loading filters…
          </p>
          <button
            type="button"
            class="cv-dm-filter-panel__clear-all"
            [disabled]="!hasActiveFilters() || filtersLoading()"
            (click)="clearAllFilters()"
          >
            Clear all
          </button>
        </div>
        <div class="cv-dm-filter-grid">
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="bm-organisation"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="Select Organisation"
              [disabled]="filtersLoading()"
              [options]="organisationOptionsModel()"
              [selectedItems]="selectedOrganisations()"
              (selectedItemsChange)="onOrganisationsFilterChange($event)"
            />
          </div>
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="bm-tags"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="Select Tags"
              [disabled]="filtersLoading()"
              [options]="tagsOptionsModel()"
              [selectedItems]="selectedTags()"
              (selectedItemsChange)="onTagsFilterChange($event)"
            />
          </div>
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="bm-types"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="Select Organisation Type"
              [disabled]="filtersLoading()"
              [options]="typesOptionsModel()"
              [selectedItems]="selectedTypes()"
              (selectedItemsChange)="onTypesFilterChange($event)"
            />
          </div>
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="bm-apiTypes"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="API Type"
              [disabled]="filtersLoading()"
              [options]="apiTypeOptionsModel"
              [selectedItems]="selectedApiTypes()"
              (selectedItemsChange)="onApiTypesFilterChange($event)"
            />
          </div>
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="bm-accessPolicy"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="Access policy"
              [disabled]="filtersLoading()"
              [options]="accessPolicyOptionsModel()"
              [selectedItems]="selectedAccessPolicies()"
              (selectedItemsChange)="onAccessPoliciesFilterChange($event)"
            />
          </div>
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="bm-crs"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="Select CRS"
              [disabled]="filtersLoading()"
              [options]="crsOptionsModel()"
              [selectedItems]="selectedCrs()"
              (selectedItemsChange)="onCrsFilterChange($event)"
            />
          </div>
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="bm-themes"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="Themes Filter"
              [disabled]="filtersLoading()"
              [options]="themesOptionsModel()"
              [selectedItems]="selectedThemes()"
              (selectedItemsChange)="onThemesFilterChange($event)"
            />
          </div>
        </div>
      </div>

      <div class="cv-dm-list">
        <div
          *ngFor="let row of filteredHits()"
          class="cv-dm-item"
          [class.cv-dm-item--expanded]="isExpanded(row.hit.resourceId)"
        >
          <div class="cv-dm-item__row">
            <div class="cv-dm-item__info">
              <span class="cv-dm-item__name">{{ row.name }}</span>
              <span class="cv-dm-item__provider" *ngIf="row.provider">{{
                row.provider
              }}</span>
            </div>
            <div class="cv-dm-item__actions">
              <span
                class="cv-dm-item__badge cv-dm-item__badge--{{
                  row.access | lowercase
                }}"
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path
                    d="M12 2a15.3 15.3 0 0 1 0 20M12 2a15.3 15.3 0 0 0 0 20"
                  />
                </svg>
                {{ row.access }}
              </span>
              <button
                type="button"
                class="cv-dm-item__expand-btn"
                [class.cv-dm-item__expand-btn--open]="
                  isExpanded(row.hit.resourceId)
                "
                (click)="toggleExpand(row.hit.resourceId)"
                [attr.aria-label]="
                  isExpanded(row.hit.resourceId) ? 'Collapse' : 'Expand'
                "
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>
            </div>
          </div>

          <div
            class="cv-dm-item__detail"
            *ngIf="isExpanded(row.hit.resourceId)"
          >
            <div class="cv-dm-item__detail-actions">
              <div class="cv-dm-item__detail-btns">
                <lib-canvas-dataset-load-buttons
                  [dataset]="resolveLoadDataset(row)"
                  [disabled]="catalogueEnrichLoading()"
                  [actionsDisabled]="!canLoadDataset(resolveLoadDataset(row))"
                  (getAll)="onGetAllClick($event)"
                  (bboxFilter)="onBboxFilterClick($event)"
                  (attrFilter)="onAttrFilterClick($event)"
                  (getStacList)="onStacListClick($event)"
                  (loadTiles)="onLoadTilesClick($event)"
                ></lib-canvas-dataset-load-buttons>
              </div>
              <div class="cv-dm-item__detail-icons">
                <button
                  type="button"
                  class="cv-dm-item__icon-btn"
                  title="Download"
                  [disabled]="
                    !row.dataset || isDownloadBusy(row.hit.resourceId)
                  "
                  (click)="onDownloadClick(row, $event)"
                >
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </button>
                <button
                  type="button"
                  class="cv-dm-item__icon-btn"
                  title="Open in new tab"
                  (click)="openDatasetDetail(row.hit.resourceId, $event)"
                >
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                    />
                    <polyline points="15 3 21 3 21 9" />
                    <line x1="10" y1="14" x2="21" y2="3" />
                  </svg>
                </button>
              </div>
            </div>

            <p
              class="cv-dm-item__access-msg"
              *ngIf="row.dataset && showsNoAccessMessage(row.hit.resourceId)"
            >
              User does not have access to this dataset. Please
              <button
                type="button"
                class="cv-dm-item__access-link"
                (click)="onRequestAccessClick(row.hit.resourceId, $event)"
              >
                request access
              </button>
              to download.
            </p>

            <p
              class="cv-dm-item__access-msg"
              *ngIf="row.dataset && showsFileNotFoundMessage(row.hit.resourceId)"
            >
              File not found.
            </p>
          </div>
        </div>

        <div class="cv-dm-empty" *ngIf="filteredHits().length === 0">
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <p *ngIf="hits.length === 0">No resources found in this area.</p>
          <p *ngIf="hits.length > 0">No resources match the current filters.</p>
        </div>
      </div>
    </div>
  </div>
</div>
